<template>
    <BreadCrumb PageTitle="Liste des pays" />
    <ListePays/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListePays from "../../components/Ecommerce/Pays/ListePays.vue";

    export default defineComponent({
      name: "ListePaysPage",
      components: {
        BreadCrumb,
        ListePays,
      },
    });
  </script>